/**
 * 關卡式範本編輯器的共用常數。
 */

/** 一關最多幾題（與後端 `DiaryQuestDef.MAX_QUEST_PER_UNIT` 一致） */
export const MAX_QUEST_PER_UNIT = 4;

/** 關卡名稱長度上限（與後端 `TemplateUnitService.UNIT_NAME_MAX` 一致） */
export const UNIT_NAME_MAX = 60;

/** 上傳封面圖的原檔上限，與後端 `QuestThumbnailService.MAX_UPLOAD_BYTES` 一致 */
export const THUMB_MAX_MB = 10;
export const THUMB_MAX_BYTES = THUMB_MAX_MB * 1024 * 1024;

/// HEIC 是 iPhone 的預設格式，老師很可能直接丟原檔，所以要收
export const THUMB_ACCEPT = 'image/jpeg,image/png,image/webp,image/heic,image/heif';

/**
 * 題目沒有設縮圖時，**學生端會看到的預設圖**。
 *
 * ⚠ 這是暫時的佔位圖。**學生端目前根本沒有正式的預設圖**——
 * `studio-web/src/components/view/ChapterPanel.vue` 在 `video_thumbnail_url` 為空時
 * 直接塞 `https://picsum.photos/id/20/300`（填充圖服務），所以既有資料裡有 53 筆
 * 是那個網址。等學生端定案後，把這個常數的值換成同一張圖即可，其他地方不必動。
 *
 * 用 data URI 而不是檔案，是為了不牽動 build 的資產處理；換成正式網址時
 * 直接把整個字串換成 URL 即可，使用端都是 `<img :src>`。
 */
export const DEFAULT_QUEST_THUMBNAIL =
    'data:image/svg+xml;charset=utf-8,'
    + encodeURIComponent(
        '<svg xmlns="http://www.w3.org/2000/svg" width="172" height="120" viewBox="0 0 172 120">'
        + '<rect width="172" height="120" fill="#e8eaec"/>'
        + '<path d="M0 92l44-34 30 23 34-30 64 49v20H0z" fill="#cfd4d8"/>'
        + '<circle cx="126" cy="34" r="15" fill="#cfd4d8"/>'
        + '</svg>');
